import * as React from 'react';

import {CardWidget} from 'shells/card/card-widget/card-widget';
// @ts-expect-error - imported from .js/.jsx file
import {CalendarIcon} from 'shells/icon/svg/calendar-icon';

import {useGetActivitiesForWidget} from '../../../core-entity/widgets/activities-widget/graphql/hooks/use-get-activities-for-widget';

import {ListWithSeeMoreModal} from '../list-with-see-more-modal';

import {ActivityRow} from './activity-row';
import {ACTIVITY_LIST_MAX_ITEMS} from './consts';

type Props = {
    leadId: string;
    hasBorder?: boolean;
};

/* DEPRECATED: use ActivitiesWidget instead. */
export function ActivityWidgetWrapper(props: Props) {
    const {activities, isLoading, refetch} = useGetActivitiesForWidget(props.leadId, 0);

    const handleAddActivity = React.useCallback(() => {
        window.location.hash = `/create/activities/${props.leadId}`;
    }, [props.leadId]);

    // Set up event listener so if an activity is created while this component
    // is mounted (meaning the user is on a lead page), we will refetch
    // activities
    React.useEffect(() => {
        const handleActivityChange = () => {
            refetch();
        };

        window.addEventListener('activityCreated', handleActivityChange);
        window.addEventListener('activityLogged', handleActivityChange);
        window.addEventListener('activityDeleted', handleActivityChange);

        return () => {
            window.removeEventListener('activityCreated', handleActivityChange);
            window.removeEventListener('activityLogged', handleActivityChange);
            window.removeEventListener('activityDeleted', handleActivityChange);
        };
    }, [refetch]);

    const isEmpty = activities ? activities.length === 0 : true;

    return (
        <CardWidget
            title='ACTIVITIES'
            addButtonProps={{
                variant: 'singular',
                onClick: handleAddActivity,
                label: '+ Schedule activity',
            }}
            isFullHeight={true}
            isFullWidth={true}
            isLoading={isLoading}
            emptyStateProps={{
                isEmpty: isEmpty,
                text: 'No upcoming activities',
                icon: CalendarIcon,
                iconSize: 18,
            }}
            hasBorder={props.hasBorder}
            minExpandedHeight={120}
            rowsHavePadding={false}
        >
            {activities && (
                <ListWithSeeMoreModal
                    items={activities}
                    renderRow={(item, handleCloseListModal) => (
                        <ActivityRow
                            key={item.id}
                            activityId={item.id}
                            name={item.name}
                            participants={item.participants}
                            startTime={item.startTime}
                            endTime={item.endTime}
                            hasExternalMeeting={Boolean(item.externalMeeting)}
                            onClick={() => {
                                if (handleCloseListModal) {
                                    handleCloseListModal();
                                }
                                window.location.hash = `/activities/${item.id}`;
                            }}
                        />
                    )}
                    maxVisibleItems={ACTIVITY_LIST_MAX_ITEMS}
                    pluralNoun='activities'
                    modalHeader='All scheduled activities'
                />
            )}
        </CardWidget>
    );
}
